import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import KitForm from './KitForm';

function KitFormModal(props) {
  const { shown, t, kit } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [kit, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="lg"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Save Kit')}
        </h5>
        <button
          onClick={() => setModalOpen(false)}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <KitForm actionUrl="/api/inventory/kit/save" entity={kit} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => setModalOpen(false)}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="KitEditForm"
          className="btn btn-primary"
        >
          {t('Save Changes')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

KitFormModal.defaultProps = {
  shown: false,
  kit: { stock_id: '', items: [] },
  onSuccess: () => { },
};

KitFormModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  kit: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(KitFormModal));
